var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expand-transition',{attrs:{"appear":""}},[_c('div',{staticClass:"overflow-hidden"},[_c('v-divider',{staticClass:"mb-6 mb-sm-8"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }